"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeEmail = exports.normalizeCreditor = void 0;
const stringIsNullOrEmpty = (text) => {
    return !text || String(text).trim() === '' || String(text) === 'undefined';
};
const removeDuplicatedSpaces = (text) => {
    if (stringIsNullOrEmpty(text))
        return '';
    return text.replace(/\s+/g, ' ').trim();
};
const normalizeCodes = (creditorId) => normalizeString(creditorId).replace('#', '').toUpperCase();
const normalizeString = (value) => {
    return String(value)
        ?.trim()
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
};
const normalizeCreditor = (creditorId) => {
    if (stringIsNullOrEmpty(creditorId))
        return creditorId;
    return removeDuplicatedSpaces(normalizeCodes(creditorId)).replace(/\u00A0/g, ' ');
};
exports.normalizeCreditor = normalizeCreditor;
const normalizeEmail = (value) => typeof value === 'string' ? value.trim().toLowerCase() : value;
exports.normalizeEmail = normalizeEmail;
